import { TicketClassCategory } from '../../constants';
import { CheckoutState } from '../../state';

export const hasOnlyAddOnsSelected = (state: CheckoutState): boolean => {
    const {
        tickets: { ticketsById },
    } = state;
    const tickets = Object.values(ticketsById);
    const hasAddOnSelected = tickets.some(
        (ticket) =>
            ticket.category === TicketClassCategory.addOn &&
            ticket.selectedQuantity > 0,
    );
    const hasNonAddOnOrVariantSelected = tickets.some((ticket) => {
        const isNonAddOnSelected =
            ticket.category !== TicketClassCategory.addOn &&
            ticket.selectedQuantity > 0;
        const isVariantSelected =
            ticket.variants &&
            Object.values(ticket.variants).some(
                (variant) => variant.selectedQuantity > 0,
            );
        return isNonAddOnSelected || isVariantSelected;
    });
    return hasAddOnSelected && !hasNonAddOnOrVariantSelected;
};
